import { QueryKey } from '@/configs/queryKeys';
import { Attribute } from './AttributeApi';
import {
	Attachment,
	CreatorAction,
	Relation,
	Translations,
	UUID,
} from '@/types/types';
import EntityApi, { BaseEntity } from './EntityApi';

export interface AttributeValue extends BaseEntity {
	value: string;
	displayName: string;
	attribute?: Attribute;
	attributeId: UUID;
	description: string;
	disclaimer: string;
	listOrder: number;
	image?: Attachment;
	price: number;
	actions: CreatorAction[];
	relations: Relation[];
	isCustomAnswer: boolean;
	translations: Translations<{
		displayName: string;
		description: string;
		disclaimer: string;
	}>;
}

class AttributeValueApi extends EntityApi<AttributeValue> {
	constructor() {
		super(QueryKey.attributeValues);
	}
}

export default new AttributeValueApi();
